import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
const FONT_STYLE = `
    .reports-hero-grain::after {
        content: '';
        position: absolute;
        inset: 0;
        background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.04'/%3E%3C/svg%3E");
        pointer-events: none;
        z-index: 10;
    }
`;
const ReportsHero = () => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <style>{FONT_STYLE}</style>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute top-0 right-0 w-[50%] h-full opacity-5 pointer-events-none"><svg viewBox="0 0 100 100" className="w-full h-full fill-current text-[#0F1C2E]"><circle cx="80" cy="20" r="40" /><rect x="60" y="40" width="30" height="80" transform="rotate(45)" /></svg></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0,
      x: -20
    };
    t3 = {
      opacity: 1,
      x: 0
    };
    t4 = {
      duration: 1,
      delay: 0.2
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <motion.div initial={t2} animate={t3} transition={t4} className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6"><div className="w-8 h-px bg-[#DF6D2A]" /><span className="font-body text-[10px] tracking-[0.3em] uppercase text-[#DF6D2A]">{"Policy & Research"}</span></motion.div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 0,
      y: 30
    };
    t7 = {
      opacity: 1,
      y: 0
    };
    t8 = {
      duration: 1,
      delay: 0.4
    };
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <br />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <motion.h1 initial={t6} animate={t7} transition={t8} className="font-display text-[34px] sm:text-[48px] md:text-[64px] lg:text-[80px] leading-[0.95] text-[#0F1C2E] tracking-tight uppercase max-w-[800px]">Official {t9} <em className="text-[#DF6D2A] italic">Reports Database</em></motion.h1>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <>{t0}<section className="relative min-h-[380px] h-[55vh] sm:h-[60vh] max-h-[600px] bg-[#EBE5D9] overflow-hidden flex flex-col justify-center border-b border-[#0F1C2E]/10 reports-hero-grain">{t1}<div className="max-w-[1400px] mx-auto w-full px-4 sm:px-6 md:px-12 relative z-20 flex flex-col items-start mt-6 sm:mt-8 md:mt-10">{t5}{t10}<motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 1,
            delay: 0.8
          }} className="font-body text-[14px] sm:text-[16px] md:text-[18px] text-[#4C596B] font-light mt-5 sm:mt-6 md:mt-8 max-w-[550px] leading-[1.7] sm:leading-[1.8]">A consolidated repository of government commissions, NGO findings, census data, and academic demographic reports spanning 15 Girmitiya nations.</motion.p></div></section></>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
};
export default ReportsHero;